import { signOut, useSession } from 'next-auth/react';

export const useWebUser = () => {
	const { data, update } = useSession();

	return {
		isUserLoggedIn: !!data,
		userName: data?.user?.name ?? '',
		token: data?.tpToken,
		signOut,
		refreshToken: update,
	};
};
